export const sanitizePhoneInput = (value: string) =>
  value.replace(/[\s-()]/g, "");

export const sanitizeHandle = (value: string) => value.replace(/^@/, "");

export const stripProtocol = (value: string) =>
  value
    .trim()
    .replace(/^https?:\/\//, "")
    .replace(/^www\./, "");

export const normalizeTelegramHandle = (value: string) =>
  sanitizeHandle(stripProtocol(value).replace(/^t\.me\//i, ""));

export const normalizeTwitterHandle = (value: string) =>
  sanitizeHandle(stripProtocol(value).replace(/^twitter\.com\//i, ""));

export const normalizeInstagramHandle = (value: string) =>
  sanitizeHandle(stripProtocol(value).replace(/^instagram\.com\//i, ""));

export const normalizeLinkedInPath = (value: string) =>
  stripProtocol(value)
    .replace(/^linkedin\.com\//i, "")
    .replace(/^\//, "");

export const normalizeFacebookPath = (value: string) =>
  stripProtocol(value)
    .replace(/^facebook\.com\//i, "")
    .replace(/^\//, "");

export const normalizeYouTubePath = (value: string) => {
  const stripped = stripProtocol(value);
  if (!stripped) return "";
  if (stripped.startsWith("youtu.be/")) {
    const videoId = stripped.substring("youtu.be/".length).split(/[?#&]/)[0];
    return `watch?v=${videoId}`;
  }
  const withoutDomain = stripped
    .replace(/^youtube\.com\//i, "")
    .replace(/^\//, "");
  if (withoutDomain.startsWith("watch?v=")) {
    return `watch?v=${
      withoutDomain.substring("watch?v=".length).split(/[&#]/)[0]
    }`;
  }
  if (
    withoutDomain.startsWith("channel/") ||
    withoutDomain.startsWith("c/") ||
    withoutDomain.startsWith("@")
  ) {
    return withoutDomain.split(/[?#]/)[0];
  }
  return withoutDomain.split(/[?#]/)[0];
};
